import { useEffect, useState } from "react";

let passiveSupported = false;
try {
  const options = {
    get passive() {
      // This function will be called when the browser attempts to access the passive property
      passiveSupported = true;
      return false;
    }
  };

  window.addEventListener("test", null as any, options as any);
  window.removeEventListener("test", null as any, options as any);
} catch {
  passiveSupported = false;
}

const listenersOptions = passiveSupported ? { passive: true } : false;

export const useScrollLeft = (element: HTMLElement | null) => {
  const [left, setLeft] = useState(0);

  useEffect(() => {
    const handleScroll = () => setLeft(element?.scrollLeft ?? 0);

    if (element) {
      element.addEventListener("scroll", handleScroll, listenersOptions);
      return () => element.removeEventListener("scroll", handleScroll);
    }
  }, [element]);

  return left;
};

export const useScrollTop = (
  element: HTMLElement | Window | null,
  onScroll?: (e: Event, top: number) => void,
  enabled: boolean = true
) => {
  const [top, setTop] = useState(0);

  useEffect(() => {
    // avoid touching dom and events:
    if (enabled === false || !element) {
      return;
    }

    const handleScroll = (e: Event) => {
      const newTop = element === window ? (element as Window).scrollY : (element as HTMLElement).scrollTop;
      setTop(newTop);
      onScroll && onScroll(e, newTop);
    };

    element.addEventListener("scroll", handleScroll, listenersOptions);
    return () => element.removeEventListener("scroll", handleScroll);
  }, [element, onScroll, enabled]);

  return top;
};
